import { useDialogMakePaymentContext } from './dialogMakePaymentContext';

/**
 * The saved payment method the user is paying with - what they picked from the
 * list, or the first method that can be paid with until they pick. An expired
 * method is never chosen, so with none left there is no chosen method.
 */
const useChosenPaymentMethod = () => {
	const { formValues, paymentMethods } = useDialogMakePaymentContext();

	const payableMethods = paymentMethods.filter((method) => !method.isExpired);

	const chosenPaymentMethod =
		payableMethods.find(
			(method) =>
				method.instrumentId?.toString() === formValues.paymentInstrumentId,
		) || payableMethods[0];

	return {
		chosenPaymentMethod,
		chosenInstrumentId: String(chosenPaymentMethod?.instrumentId || ''),
		requiresCVV: Boolean(chosenPaymentMethod?.requiresCVV),
	};
};

export default useChosenPaymentMethod;
